/**
 * Date display helpers (Phase 35-03 extracted shared lib via Phase 38-01).
 *
 * Pure string functions (no Date parsing) for ISO YYYY-MM-DD inputs —
 * avoids timezone drift on dates that arrive as ISO strings from the
 * backend. Used by the Time admin Timesheets table + JobDetailPanel
 * VEHICLES section + any other UK-conventional date display.
 */

/** 'YYYY-MM-DD' → 'DD/MM/YY' */
export function formatDateDDMMYY(iso: string): string {
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y.slice(2)}`;
}
